import { getRuntimeConfig } from '../runtimeConfig';

export const fetchNoAuth = async (input, init = {}, isFormData = false) => {
    const domain = getRuntimeConfig('REACT_APP_BACKEND_URL');

    const headers = {
        Accept: 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
    };

    if (!isFormData) {        
        headers['Content-Type'] = 'application/json';
    }

    const withHeaderInit = {
        ...init,
        credentials: "include",
        headers: headers
    };

    let response;
    
    try {
        response = await fetch(domain + input, withHeaderInit);

        if (!response.ok) {
            if (response?.headers.get('content-type') == 'application/json') {
                const err = await response.json();                
                throw {logicalException: true, err};
            } else {
                throw {logicalException: false};
            }
        }
        if (response.status === 204) {
            return null;
        }
    } catch (err) {
        if (err.logicalException) {
            throw err;
        }
    }
    const contentType = response?.headers.get('content-type');
    if (contentType == 'application/json') {
        return response.json();
    } else if (contentType === 'application/octet-stream' || contentType === 'application/zip') {
        return response.blob()
    }
    return response.body;
}